/* @ngInject */
const maneuverRun = (
  $transitions,
  $state,
  maneuverMenu,
  routes
) => {
  $transitions.onSuccess({
    to: routes.maneuver.index.path,
  }, (trans) => {
    const dest = routes.maneuver.index.path + '.' + maneuverMenu.radio.value.replace('Menu', '')
    $state.go(dest)
  })
}

export default maneuverRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/maneuver.run.js